// src/api/useDeleteUser.js
import { useMutation, useQueryClient } from "@tanstack/react-query";
import api from "../utils/api";

const deleteAssignmentByAdmin = async ({ assignmentId }) => {
  return api.delete(`/assignment/${assignmentId}`);
};

export const useDeleteAssignmentByAdmin = () => {
  //   const queryClient = useQueryClient();
  return useMutation({
    mutationFn: deleteAssignmentByAdmin,
  });
};
